// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};
exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */);
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */);
  },
  "component---src-portfolio-portfolio-item-tsx": function componentSrcPortfolioPortfolioItemTsx() {
    return import("./../../src/portfolio/portfolio-item.tsx" /* webpackChunkName: "component---src-portfolio-portfolio-item-tsx" */);
  },
  "component---src-portfolio-portfolio-list-tsx": function componentSrcPortfolioPortfolioListTsx() {
    return import("./../../src/portfolio/portfolio-list.tsx" /* webpackChunkName: "component---src-portfolio-portfolio-list-tsx" */);
  }
};